export * as fieldData from './field_data.json';

export const classNames = {
    CTA_BLOCK: 'ql-cta-block',
    CTA_TITLE: 'ql-cta-block-title',
    CTA_DESC: 'ql-cta-block-desc'
}
export const dataTest = {
    ...classNames
}
